import { DependencyList, useEffect } from 'react';
import { appInsights } from '../AppInsights';
import { EnterpriseGPTApiV1ClientWrapper } from '../EnterpriseGPTApi/EnterpriseGPTApiV1ClientWrapper';
import { isNotFoundError, isRequestCanceled, ServiceFactory } from '../EnterpriseGPTApi/ServiceFactory';

// use this centralized middleware to call SyGPT back-end APIs
export interface ApiCallOptions {
    abortController?: AbortController;
}

type RequestDelegate<T> = (client: EnterpriseGPTApiV1ClientWrapper, signal?: AbortSignal) => Promise<T>;

export const performEnterpriseGPTApiCall = async <T>(next: RequestDelegate<T>, options?: ApiCallOptions) => {
    try {
        const client = ServiceFactory.EnterpriseGPTApiClient();
        return await next(client, options?.abortController?.signal);
    } catch (ex: unknown) {
        if (!isRequestCanceled(ex) && !isNotFoundError(ex)) {
            appInsights.trackException({ exception: ex as Error });
        }
    }
};

export const useEnterpriseGPTApiCall = async <T>(next: RequestDelegate<T>, dependencies?: DependencyList) => {
    useEffect(() => {
        const abortController = new AbortController();

        performEnterpriseGPTApiCall(next, { abortController });

        return () => {
            abortController.abort();
        };
    }, dependencies ?? []);
};
